import * as Sentry from "@sentry/react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Network from "../../utils/Network";
import WLayout from "../common/Layout/Layout/WLayout";
import SunkhronosCompanies from "../sunkhronos/companies/SunkhronosCompanies";
import SunkhronosCompanyManagement from "../sunkhronos/company/SunkhronosCompanyManagement";
import Login from "../login/login";

const RoutesProvider = () => {
    const location = useLocation();
    const lang = location.pathname.split('/')[1] ?? "fr";
    const navigate = useNavigate();

    useEffect(() => {
        const SUPPORTED_LANGUAGES = ["en", "fr", "de"];
        const accessToken = localStorage.getItem("access");

        if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
            navigate(`/fr${location.pathname.replace(/^\/[^/]+/, "")}`, { replace: true });
            return;
        }

        const handleNavigation = (isAuthenticated: boolean) => {
            const isOnLoginPage = location.pathname.includes("/login");
            if (isAuthenticated) {
                if (isOnLoginPage) navigate(`/${lang}/sunkhronos/companies`);
            } else {
                if (!isOnLoginPage) navigate(`/${lang}/login`);
            }
        };

        //? DEV ONLY: Comment this condition to prevent disconnection while on dev mode.
        if (accessToken) {
            Network.verifyAuth(accessToken)
                .then(() => handleNavigation(true))
                .catch(() => handleNavigation(false));
        }
    }, [lang, location.pathname, navigate]);

    return (
        <div id="anchor">
            <Sentry.ErrorBoundary>
                <Routes>
                    <Route path="/" element={<Navigate to="/fr" replace />} />

                    <Route path="/:lang">
                        <Route index element={<Navigate to={`/${lang}/login`} replace />} />
                        <Route path="login" Component={Login} />
                        <Route path="" Component={WLayout}>
                            <Route path="sunkhronos/companies" Component={SunkhronosCompanies} />
                            <Route path="sunkhronos/companies/:companyId/:tab" Component={SunkhronosCompanyManagement} />
                            <Route path="*" element={<Navigate to={`/${lang}/sunkhronos/companies`} replace />} />
                        </Route>
                    </Route>
                </Routes>
            </Sentry.ErrorBoundary>
        </div>
    );

};

export default RoutesProvider;
